var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    style: {
      fill: "#fff"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 12,
    rx: 1,
    width: 8,
    x: 2,
    y: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 1,
    width: 8,
    x: 22,
    y: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 28,
    rx: 1,
    width: 8,
    x: 12,
    y: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraph);
export default __webpack_public_path__ + "static/media/icon-graph.5a6ad1a084ec973a2c83b3099373d88b.svg";
export { ForwardRef as ReactComponent };